// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/feedback.css
// module id = 2549
// module chunks = 2